import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.remove-statement-item.presenters.RemoveStatementItemPresenter`

export default defineMessages({
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Unable to remove the statement item.',
  },
})
